import React from "react";

const S = {
  panel: {
    position: "absolute", right: 8, top: 48, width: 220, zIndex: 30,
    background: "#030508", border: "1px solid #0d1520", borderRadius: 4,
    fontFamily: "'JetBrains Mono',monospace",
  },
  header: {
    padding: "6px 10px", borderBottom: "1px solid #0d1520",
    fontSize: 9, fontWeight: 700, letterSpacing: 1, color: "#f472b6",
    display: "flex", justifyContent: "space-between", alignItems: "center",
  },
  section: { padding: "6px 10px", borderBottom: "1px solid #080e16" },
  label:   { fontSize: 8.5, color: "#3b4a5a", letterSpacing: 0.5, marginBottom: 3 },
  row:     { display: "flex", alignItems: "center", gap: 6, marginBottom: 4 },
  input:   {
    flex: 1, background: "#04080f", border: "1px solid #0d1520",
    color: "#a0b4c8", borderRadius: 3, padding: "2px 5px",
    fontSize: 9, fontFamily: "inherit", height: 22, textAlign: "right",
  },
  unit:    { fontSize: 8, color: "#1e2a36", minWidth: 16 },
  btn:     {
    flex: 1, height: 22, borderRadius: 3, fontSize: 9, fontFamily: "inherit",
    background: "transparent", border: "1px solid #0d1520", color: "#6b7e94",
    cursor: "pointer", letterSpacing: 0.5,
  },
  btnPrimary: {
    flex: 1, height: 22, borderRadius: 3, fontSize: 9, fontFamily: "inherit",
    cursor: "pointer", letterSpacing: 0.5, fontWeight: 600,
  },
};

export default function TransformPanel({
  selCount,
  transformAngle,    setTransformAngle,
  transformScale,    setTransformScale,
  arrayRows,         setArrayRows,
  arrayCols,         setArrayCols,
  arrayRowSpacing,   setArrayRowSpacing,
  arrayColSpacing,   setArrayColSpacing,
  arrayCount,        setArrayCount,
  arrayTotalAngle,   setArrayTotalAngle,
  onCommand,
  onClose,
}) {
  if (!selCount) return null;

  const numInput = (val, set, min, max, step) => (
    <input type="number" value={val} min={min} max={max} step={step}
      onChange={e => set(Number(e.target.value))}
      style={S.input}
    />
  );

  return (
    <div style={S.panel}>
      <div style={S.header}>
        ⟳ TRANSFORM · {selCount} selected
        <button onClick={onClose}
          style={{ background:"transparent", border:"none", color:"#3b4a5a",
            fontSize:11, cursor:"pointer", padding:0 }}>✕</button>
      </div>

      {/* Rotate */}
      <div style={S.section}>
        <div style={S.label}>ROTATE</div>
        <div style={S.row}>
          {numInput(transformAngle, setTransformAngle, -360, 360, 15)}
          <span style={S.unit}>°</span>
          <button style={{ ...S.btnPrimary, background:"#1a1060", border:"1px solid #3b82f630", color:"#818cf8" }}
            onClick={() => onCommand({ type:"ROTATE", angle: transformAngle })}>
            Apply
          </button>
        </div>
        <div style={{ ...S.row, gap: 4 }}>
          {[-90, 90, 180].map(a => (
            <button key={a} style={{ ...S.btn, flex:"none", width:40 }}
              onClick={() => onCommand({ type:"ROTATE", angle: a })}>
              {a}°
            </button>
          ))}
        </div>
      </div>

      {/* Scale */}
      <div style={S.section}>
        <div style={S.label}>SCALE</div>
        <div style={S.row}>
          {numInput(transformScale, setTransformScale, 0.01, 100, 0.1)}
          <span style={S.unit}>×</span>
          <button style={{ ...S.btnPrimary, background:"#0a1a10", border:"1px solid #4ade8030", color:"#4ade80" }}
            onClick={() => onCommand({ type:"SCALE", factor: transformScale })}>
            Apply
          </button>
        </div>
        <div style={{ ...S.row, gap: 4 }}>
          {[0.5, 2].map(f => (
            <button key={f} style={{ ...S.btn, flex:"none", width:36 }}
              onClick={() => onCommand({ type:"SCALE", factor: f })}>
              ×{f}
            </button>
          ))}
        </div>
      </div>

      {/* Mirror */}
      <div style={S.section}>
        <div style={S.label}>MIRROR</div>
        <div style={S.row}>
          <button style={{ ...S.btn }}
            onClick={() => onCommand({ type:"MIRROR_MODE" })}>
            Pick axis (I)
          </button>
        </div>
      </div>

      {/* Rectangular Array */}
      <div style={S.section}>
        <div style={S.label}>RECTANGULAR ARRAY</div>
        <div style={S.row}>
          <span style={{ fontSize:8, color:"#2a3a4a", minWidth:20 }}>Col</span>
          {numInput(arrayCols, setArrayCols, 1, 50, 1)}
          <span style={S.unit}>×</span>
          {numInput(arrayColSpacing, setArrayColSpacing, 1, 100000, 100)}
          <span style={S.unit}>mm</span>
        </div>
        <div style={S.row}>
          <span style={{ fontSize:8, color:"#2a3a4a", minWidth:20 }}>Row</span>
          {numInput(arrayRows, setArrayRows, 1, 50, 1)}
          <span style={S.unit}>×</span>
          {numInput(arrayRowSpacing, setArrayRowSpacing, 1, 100000, 100)}
          <span style={S.unit}>mm</span>
        </div>
        <div style={S.row}>
          <button style={{ ...S.btnPrimary, background:"#0a1418", border:"1px solid #22d3ee30", color:"#22d3ee" }}
            onClick={() => onCommand({ type:"ARRAY_RECT" })}>
            Create array
          </button>
        </div>
      </div>

      {/* Polar Array */}
      <div style={{ ...S.section, borderBottom:"none" }}>
        <div style={S.label}>POLAR ARRAY</div>
        <div style={S.row}>
          <span style={{ fontSize:8, color:"#2a3a4a", minWidth:20 }}>Cnt</span>
          {numInput(arrayCount, setArrayCount, 2, 360, 1)}
          <span style={S.unit}></span>
          <span style={{ fontSize:8, color:"#2a3a4a", minWidth:16 }}>Arc</span>
          {numInput(arrayTotalAngle, setArrayTotalAngle, 1, 360, 45)}
          <span style={S.unit}>°</span>
        </div>
        <div style={S.row}>
          <button style={{ ...S.btnPrimary, background:"#100a18", border:"1px solid #818cf830", color:"#818cf8" }}
            onClick={() => onCommand({ type:"ARRAY_POLAR" })}>
            Create polar array
          </button>
        </div>
      </div>
    </div>
  );
}
